module.exports = __webpack_public_path__ + "static/media/pdp_paperDoubleThick.28b32397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/comparison-module/pdp_paperDoubleThick.jpg
// module id = 1432
// module chunks = 71